/* Movus-Media v2, gedeeld script voor alle pagina's: menu, inkomen bij scrollen en de bol achter de pagina.
   Paginaspecifieke beweging (intro, hub, bento, tabbladen) staat in de pagina zelf. */
(() => {
  const rustig = matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.movusRustig = rustig;
  document.documentElement.classList.add("js");
  document.querySelectorAll(".jaar").forEach(j => j.textContent = new Date().getFullYear());
  gsap.registerPlugin(ScrollTrigger);

  /* ---- menu wordt een zwevende pil ---- */
  const menu = document.getElementById("menu");
  const zetMenu = () => menu.classList.toggle("zweeft", scrollY > 80);
  addEventListener("scroll", zetMenu, { passive: true }); zetMenu();

  /* Calendly: de knoppen gaan naar de slotsectie, die de link heeft */
  document.querySelectorAll("[data-gesprek]").forEach(a => a.setAttribute("href", "#gesprek"));

  /* ---- elementen schuiven in beeld bij scrollen ---- */
  if (!rustig) {
    ScrollTrigger.batch(".in", {
      start: "top 88%",
      onEnter: els => gsap.to(els, { opacity: 1, y: 0, duration: .9, stagger: .08, ease: "power3.out", overwrite: true }),
    });
  }

  /* ---- werkwijze: de lijn boven de stappen vult zich mee met het scrollen ---- */
  document.querySelectorAll(".pad").forEach(pad => {
    const stappen = pad.querySelectorAll(".stap");
    if (rustig) { stappen.forEach(s => { s.classList.add("aan"); s.querySelector(".vul").style.transform = "none"; }); return; }
    const tl = gsap.timeline({ scrollTrigger: { trigger: pad, start: "top 75%", end: "bottom 60%", scrub: .6 } });
    stappen.forEach((s, i) => tl.to(s.querySelector(".vul"), {
      scaleX: 1, ease: "none", duration: 1,
      onStart: () => s.classList.add("aan"), onReverseComplete: () => s.classList.remove("aan"),
    }, i));
  });

  /* ---- cijfers tellen op als ze in beeld komen ---- */
  document.querySelectorAll("[data-tel]").forEach(el => {
    const doel = parseFloat(el.dataset.tel), dec = (el.dataset.tel.split(".")[1] || "").length;
    const zet = v => el.textContent = v.toFixed(dec).replace(".", ",");
    if (rustig) return;
    const o = { v: 0 }; zet(0);
    gsap.to(o, { v: doel, duration: 1.6, ease: "power2.out", onUpdate: () => zet(o.v), scrollTrigger: { trigger: el, start: "top 90%", once: true } });
  });

  /* ---- prototype: het formulier verstuurt nog niets (in Shopify wordt dit het contactformulier) ---- */
  document.querySelectorAll("form[data-prototype]").forEach(f => f.addEventListener("submit", e => {
    e.preventDefault();
    f.querySelector(".melding").hidden = false;
  }));

  /* ---- stippenbol: Fibonacci-punten op een bol, alleen de voorkant ---- */
  const doek = document.getElementById("bol");
  if (!doek) return;
  const ctx = doek.getContext("2d");
  const N = 2600, punten = [];
  for (let i = 0; i < N; i++) {
    const y = 1 - (i / (N - 1)) * 2, r = Math.sqrt(1 - y * y), t = Math.PI * (3 - Math.sqrt(5)) * i;
    punten.push([Math.cos(t) * r, y, Math.sin(t) * r]);
  }
  let hoek = 0, laatste = 0;
  // Positie: bovenaan de pagina zie je de bovenkant van de bol onderin beeld, onderaan de onderkant bovenin beeld.
  const vast = document.getElementById("bolVast");
  function plaats() {
    const D = vast.offsetWidth, r = D * .41, H = innerHeight;
    const max = Math.max(1, document.documentElement.scrollHeight - H), p = Math.min(1, Math.max(0, scrollY / max));
    const kap = Math.min(r * .55, H * .42);                       // zoveel van de bol is aan de randen te zien
    const midden = (H + r - kap) + ((-r + kap) - (H + r - kap)) * p;
    vast.style.transform = `translate3d(-50%, ${midden - D / 2}px, 0)`;
  }
  addEventListener("scroll", () => requestAnimationFrame(plaats), { passive: true });
  addEventListener("resize", plaats); addEventListener("load", plaats); plaats();

  function maat() { const d = Math.min(devicePixelRatio, 1.5); doek.width = doek.clientWidth * d; doek.height = doek.clientHeight * d; }
  function teken(tijd) {
    if (!rustig) hoek += Math.min(tijd - laatste, 50) * 0.00006;
    laatste = tijd;
    const w = doek.width, h = doek.height, R = w * .41, cx = w / 2, cy = h / 2;
    ctx.clearRect(0, 0, w, h);
    const s = Math.sin(hoek), c = Math.cos(hoek), kant = .38, ks = Math.sin(kant), kc = Math.cos(kant);
    for (const [x, y, z] of punten) {
      const x1 = x * c + z * s, z1 = -x * s + z * c;          // draaien om de y-as
      const y2 = y * kc - z1 * ks, z2 = y * ks + z1 * kc;      // iets voorover gekanteld
      if (z2 < 0) continue;
      const a = Math.pow(z2, 1.4);
      ctx.fillStyle = `rgba(255,${200 + 40 * a | 0},${190 + 50 * a | 0},${.12 + .7 * a})`;
      // vierkantjes in plaats van rondjes: op deze grootte zie je het verschil niet, en het tekent veel sneller
      const px = cx + x1 * R, py = cy - y2 * R, rr = (1 + 1.6 * a) * (w / 1400);
      ctx.fillRect(px - rr, py - rr, rr * 2, rr * 2);
    }
    if (!rustig && !document.hidden) requestAnimationFrame(teken);
  }
  addEventListener("resize", () => { maat(); if (rustig) teken(performance.now()); });
  document.addEventListener("visibilitychange", () => { if (!document.hidden && !rustig) { laatste = performance.now(); requestAnimationFrame(teken); } });
  maat(); laatste = performance.now(); requestAnimationFrame(teken);
})();
